import { useMemo } from "react";
import {
  applyFormListQuery,
  getFormListStats,
  type FormListQueryState,
} from "../lib/admin/formListFilters";
import type { FormListItemDto } from "../types/formList";

export function useFormListFilters(
  forms: FormListItemDto[],
  query: FormListQueryState,
) {
  const stats = useMemo(() => getFormListStats(forms), [forms]);

  const filteredForms = useMemo(
    () => applyFormListQuery(forms, query),
    [
      forms,
      query.search,
      query.status,
      query.source,
      query.organisationId,
      query.sortBy,
      query.sortDir,
    ],
  );

  return {
    filteredForms,
    stats,
  };
}

export type {
  FormListQueryState,
  FormListStats,
  FormSourceFilter,
  FormStatusFilter,
} from "../lib/admin/formListFilters";
